import Splide from '@splidejs/splide';
import PhotoSwipeDynamicCaption from './photoswipe-dynamic-caption-plugin.esm.min.js';
import './photoswipe-dynamic-caption-plugin.css';

export function createGalleryCaptions(lightbox){
  new PhotoSwipeDynamicCaption(lightbox, {
    type: 'below',
    captionContent: '.pswp-caption-content'
  });

  lightbox.on('beforeOpen', () => {
    const gallery = lightbox.options.dataSource.gallery;
    const captions = gallery.querySelectorAll('.pswp-caption-content');
    captions.forEach(caption => {
      const url = caption.getAttribute('data-link');
      const label = caption.getAttribute('data-caption');
      const link = document.createElement('a');
      link.href = url;
      link.innerHTML = label;

      caption.appendChild(link);
    });
  });
}

export function createThumbnailsSlider(lightbox){
  lightbox.on('uiRegister', function() {
    lightbox.pswp.ui.registerElement({
      name: 'thumbnails',
      className: 'pswp__thumbnails',
      appendTo: 'wrapper',
      onInit: (el, pswp) => {
        const splideItems = [];

        const splideContainer = document.querySelector('#thumbnail-slider');

        if (!splideContainer) return;

        const clone = splideContainer.cloneNode(true);

        clone.classList.remove('d-none');

        el.appendChild(clone);

        const splideThumbnails = new Splide(clone, {
          rewind: true,
          fixedWidth: 150,
          fixedHeight: 100,
          isNavigation: true,
          gap: 5,
          focus: 'center',
          trimSpace: false,
          pagination: false,
          mediaQuery: 'min',
        });

        splideThumbnails.mount();

        for (let i = 0; i < pswp.getNumItems(); i++) {
          const img = lightbox.options.dataSource.items[i];
          const splideSingleItem = document.createElement('div');
          const thumbnail = document.createElement('img');
          
          splideSingleItem.className = 'pswp__thumbnail splide__slide';

          thumbnail.src = img.href;
          splideSingleItem.appendChild(thumbnail);

          splideThumbnails.add(splideSingleItem);

          splideItems.push(splideSingleItem);

          splideSingleItem.onclick = () => {
            pswp.goTo(i);
          };
        }
  
        pswp.on('change', (a,) => {
          splideItems.forEach(item =>{
            item.classList.remove('is-active');
          })
          splideItems[pswp.currIndex].classList.add('is-active');
          splideThumbnails.go(pswp.currIndex);
        });

        splideThumbnails.on('move', function () {
          splideItems[splideThumbnails.index].classList.add('is-active');
          pswp.goTo(splideThumbnails.index);
        });
      }
    });
  });
}

export function galleryOnClose(lightbox){
  lightbox.on('close', () => {
    const gallery = lightbox.options.dataSource.gallery;
    const links = gallery.querySelectorAll('.pswp-caption-content a');
    links.forEach(link => {
      link.remove();
    });
  });
}

export function galleryOnExpand(galleryMoreBtn, galleries){
  galleryMoreBtn.addEventListener('click', () => {
    galleries.forEach(gallery => {
      gallery.classList.remove('d-none');
      galleryMoreBtn.parentNode.remove();
    });
  });
}